var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDownload(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 11.906 13.229",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.576.501l4.942.904H1.576zm7.88 11.288a1.01 1.01 0 01-1.009 1.008H.44V1.758h8.008a1.01 1.01 0 011.009 1.009v1.498h.353V2.752 2.75c-.01-.706-.558-1.284-1.224-1.337a1.612 1.612 0 00-.122-.007L1.223.079v1.327H.086V13.15h8.361c.75 0 1.362-.61 1.362-1.361v-1.388h-.353z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.603 8.17h2.403v-.352H2.603zM2.603 9.511H5.92v-.353H2.603zM5.92 5.057H2.603v.353H5.92zM5.006 6.526H2.603v.353h2.403zM10.918 7.359V4.996H8.243v2.363h.352v-2.01h1.97v2.01z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.656 7.816L9.581 9.372 7.547 7.818v-.46h-.353v.634l2.385 1.822 2.43-1.821v-.634h-.353z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.99cf8c2a.svg";
export { ForwardRef as ReactComponent };